



































































import { required, email } from "@vuelidate/validators";
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from "@vue/composition-api";
import { useMachine } from "@xstate/vue";
import useVuelidate from "@vuelidate/core";

import { AuthenticationApi, RequestPasswordResetTokenRequest } from "@/api";
import { mapValidationErrors } from "@/util/Forms";
import RequestResetPasswordMachine from "./RequestResetPasswordMachine";

interface RequestPasswordResetForm {
  valid: boolean;
  errors: {};
  fields: RequestPasswordResetTokenRequest;
  validations: {};
}

const Component = defineComponent({
  setup() {
    const emailAddress = ref("");

    const { state, send, service } = useMachine(RequestResetPasswordMachine);
    const api = new AuthenticationApi();

    const form: RequestPasswordResetForm = reactive({
      valid: false,

      fields: {
        emailAddress,
      },

      errors: {},

      validations: useVuelidate(
        {
          emailAddress: {
            required,
            email,
            $autoDirty: true,
          },
        },
        { emailAddress }
      ),
    });

    const requestPasswordReset = async () => {
      try {
        await api.authenticationRequestPasswordResetToken(form.fields);
        service.send("RESOLVE");
      } catch (err) {
        form.errors = err.response.data.errors;
        service.send("REJECT");
      }
    };

    onMounted(() => {
      service.subscribe((s) => {
        if (s.matches("loading")) {
          requestPasswordReset();
        }
      });
    });

    return {
      form,
      mapValidationErrors,
      service,
      send,
      state,
    };
  },
});

export default Component;
